import React, {cloneElement, useContext, useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {TableColumn, TableSettings} from "../../../tableSettings";
import AbstractListView, {
  DataFetchResult,
  ExportRowRenderer,
  ListCustomFilterRenderer,ListOrderBy,ListRowRenderer
} from "../../common/AbstractListView";

import lockBlue from '../../../img/lock_blue.png';
import lockRed from '../../../img/lock_red.png';
import iManifestIcon_blue from '../../../img/iManifest-blue.svg';

import constants from '../../../constants';
import Select from "../../../ui/Select";
import {FilterStorageVersion, Search} from "../../../filtering";

import {NavigationType, openNewPage} from '../../../util/navigationHelpers';

import {
  DateRenderer,DateTimeRenderer,
  FloatRenderer,
  NullableCheckboxIconRenderer,
  TextAlignLeftRenderer,TextAlignRightRenderer,TextRenderer
} from '../../../uiControls/SmartTableRenderers';
import UniqueLinkButton from '../../../uiControls/UniqueLinkButton';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import { faCalculator, faCopy, faFileAlt, faPencilAlt, faPlus, faTrashAlt, } from '@fortawesome/free-solid-svg-icons';
import useGlobalYesNoDialog from '../../../hooks/useGlobalYesNoDialog';
import ApplicationContext from '../../../ApplicationContext';
import JobListViewContext, { IJobListViewContext, RightClickContext } from '../../common/JobListViewContext';
import useGlobalOkDialog from '../../../hooks/useGlobalOkDialog';
import {ActionButtonItem, borderColors, splitMenuItemsIntoSections} from '../../../ui/ActionButton';
import useFunctionKeys from '../../../hooks/useFunctionKeys';
import PrimaryButton from '../../../ui/PrimaryButton';
import InfoAreaDrawer from '../../../uiControls/infoArea/InfoAreaDrawer';
import {JobNames} from "../../../framework.core/JobNames";
import {brokerageTruckingOrderList} from "../tableSettings";
import IfmsModal from "../../../ui/IfmsModal";
import ListViewShortcutMenu from '../../common/ListViewShortcutMenu';
import ToolboxMenuItem from '../../../uiControls/ToolboxMenuItem';
import Menu, { IfmsMenuItem } from '../../../ui/menu/Menu';
import JobListSuntekCommand from '../../common/JobListSuntekCommand';
import {BillInvoiceCrdbFilterRenderer, MOTFilterRenderer, RecognizedFilterRenderer, RecognizedRenderer, RQFilterRenderer} from '../../common/commonListRenderers';
import * as XCol from '../../../framework.core/XExportColumn';
import DeleteHistory from "../../reports/DeleteHistory";
import { FmsSubMenu } from '../../../constants/fmsSubMenu';
import { getSelectedSubMenuArgs } from '../../JobListSubMenu';
import useReportViewer from '../../../hooks/useReportViewer';
import postal from 'postal';
import loadInfoAreaInvoiceBillCrDb from '../../common/InfoAreaInvoiceBillCrDb';
import { FmsSecTask, ListFilterType } from '../../../fms.core/constants';
import { getFmsGlobal } from '../../../globals';
import { findSecurityTask, isNullOrEmpty } from '../../../util';
import { useJournal } from '../../accounting/general/journal/JournalListView';
import useSuntekSettings from '../../../hooks/useSuntekSettings';
import { BTOrderListItem } from '../../../fms.data/models/BTOrderListItem';
import { useTypedFastStorage } from '../../../hooks/useFastStorage';
import fastStorage from '../../../fastStorage';
import _ from 'lodash';
import { ApiResult, InsertResultsWithData } from '../../../framework.core/data/ApiResult';
import { RequestType } from '../../../fms.core/TrackRequest';
import CheckBoxIcon from '../../../ui/CheckBoxIcon';
import PrimaryInverseButton from '../../../ui/PrimaryInverseButton';
import CustomerBalanceDetails from '../../reports/AccountBalance';
import { formatDateTime, now, nowDate } from '../../../dateUtils';
import EmailOptionPopup from '../../reports/EmailOption';
import TrackingRequest from '../../reports/TrackingRequest';
import OrchidTracking_Y from '../../../img/orchid_tracking-yellow.svg';
import OrchidTracking_R from '../../../img/orchid_tracking-red.svg';
import OrchidTracking_B from '../../../img/orchid_tracking-blue.svg';
import OrchidTracking_G from '../../../img/orchid_tracking-green.svg';
import OrchidTrackingIcon from '../../../img/orchid_tracking.svg';
import OrchidTracking_Wh from '../../../img/orchid_tracking-white.svg'
import OrchidTracking_Bl from '../../../img/orchid_tracking-black.svg'
import ManifestTrackingIcon from '../../../img/manifest_tracking.svg';
import UseAMSISfIcon from '../../../img/Isf_P_circle.svg';
import useSetEditedId from '../../../hooks/useSetEditedId';
import RecogModal from '../../../ui/RecogModal';
import { SQLField, SQLInfo, SQLType } from '../../../framework.core/data/SQLInfo';
import { Decimalformat, nullableCheckBoxValue } from '../../common/commonExportFormat';
import { formatTrackingType } from '../../common/utils/formatUtils';
import { useAppSelector } from '../../../app/hooks';
import { RtdShipInfo } from '../../../fms.core/RtdShipInfo';

let vcResult = '';

function IndicatorRenderer({ data, row }: any) {
  const l = data[row.index];
  let dataTooltip = '';
  const lStatus = (l as any).status as string;
  if (lStatus === 'PC') dataTooltip = 'Period Close';
  else if (lStatus === 'OC') dataTooltip = 'OP Close';

  let content: React.ReactNode = <></>;
  if (lStatus === 'PC')
    content = <img height="7px" src={lockRed} id={'redIcon'} style={{ position: 'relative', top: '0px' }} alt="" />;
  else if (lStatus === 'OC')
    content = <img height="7px" src={lockBlue} id={'blueIcon'} style={{ position: 'relative', top: '0px' }} alt="" />;
  return (
    <div className="ifms-table-default" id={`ifms-table-default-${row.index}`} data-tooltip={dataTooltip} style={{ width: '100%', minHeight: '22px' }}>{content}</div>
  );
}

function AmsRenderer({ cell, row, data }: any) {
  const l = data[row.index];
  const useAms = (l as any).useAms as boolean;

  if (useAms) {
    const content = <img height="13px" src={UseAMSISfIcon} alt="" />;

    if (cell && cell.value) {
      return (
        <div className="ifms-table-default" id={`ifms-table-default-${row.index}`} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', minHeight: '22px' }}>{content}</div>
      );
    }
  } else {
    if (cell && cell.value) {
      return <div id={`${cell.column.id}-${row.index}`} className="ifms-table-default">
        <CheckBoxIcon value={true} />
      </div>;  
    }
  }

  return <div className="ifms-table-default ifms-check-box-icon-false"></div>;
}



function LastEventRenderer({ cell, row, data }: any) {
  const l = data[row.index];
  const lastEventDate = (l as any).lastEventDate as string;
  const trDate = (l as any).trDate as string;
  const jobListContext = useContext(JobListViewContext);

  const appContext = useContext(ApplicationContext);
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const setSavedEntity = useSetEditedId([JobNames.BTOrder]);

  const trStatus = cell.value;
  const lastEvent = (l as any).lastEvent as string;
  const fmsGlobal = getFmsGlobal();
  let imgSrc = null;

  let tooltip = '';
  let displayText = '';
  let displayDateTime = '';
  let id='';
  let link = `https://quicktrack2.suntekscm.com/?licid=${fmsGlobal.AcmeID}&mbl=${cell.row.original.mblNo}&hbl=${cell.row.original.hblNo}&cntr=${cell.row.original.containerNo}&email=${appContext.user?.email}`;
  let trakcingImgSrc = ManifestTrackingIcon;

  async function goToTive(trackingNo: string) {
    jobListContext.setRowExtrasId(cell.row.original.id);
  
    if (trackingNo) {
      // let sharedUrl = await appContext.api.getSharedUrl(trackingNo);
      const apiResult1: ApiResult<RtdShipInfo> = await appContext.api.getRtdShipInfo(trackingNo);
      
      if (apiResult1 && apiResult1.success) {
        if (cell.row.original.id > 0) {
          let sqlInfos: SQLInfo[] = [];
          sqlInfos.push(new SQLInfo({
            tableName: "T_BTORDER",
            type: SQLType.Update,
            fields:[
              new SQLField({fieldName: "F_SharedURL", propertyName:'SharedURL', value: apiResult1.result.shipmentId}),
              new SQLField({fieldName: "F_TrackingNo", propertyName:'TrackingNo', value: trackingNo}),
            ],
            whereFields:[
              new SQLField({fieldName:"F_ID", propertyName:'', value: cell.row.original.id})
            ]
          }))

          sqlInfos.push(new SQLInfo({
            tableName: 'BTRTDSHIPINFO',
            type: SQLType.Insert,
            fields: [
              new SQLField({ fieldName: 'ShipmentId', propertyName: 'ShipmentId', value: apiResult1.result.shipmentId }),
              new SQLField({ fieldName: 'SharedUrl', propertyName: 'SharedUrl', value: apiResult1.result.sharedUrl }),
              new SQLField({ fieldName: 'ShipFrom', propertyName: 'ShipFrom', value: apiResult1.result.shipFrom }),
              new SQLField({ fieldName: 'ShipTo', propertyName: 'ShipTo', value: apiResult1.result.shipTo }),
              new SQLField({ fieldName: 'DepartureUtc', propertyName: 'DepartureUtc', value: apiResult1.result.departureUtc }),
              new SQLField({ fieldName: 'FromTZOffset', propertyName: 'FromTZOffset', value: apiResult1.result.fromTZOffset }),
              new SQLField({ fieldName: 'CurrentLoc', propertyName: 'CurrentLoc', value: apiResult1.result.currentLoc }),
              new SQLField({ fieldName: 'EtaUtc', propertyName: 'EtaUtc', value: apiResult1.result.etaUtc }),
              new SQLField({ fieldName: 'CurrentEtaUtc', propertyName: 'CurrentEtaUtc', value: apiResult1.result.currentEtaUtc }),
              new SQLField({ fieldName: 'ToTZOffset', propertyName: 'ToTZOffset', value: apiResult1.result.toTZOffset }),
              new SQLField({ fieldName: 'DistanceLeft', propertyName: 'DistanceLeft', value: apiResult1.result.distanceLeft }),
              new SQLField({ fieldName: 'CompletedUtc', propertyName: 'CompletedUtc', value: apiResult1.result.completedUtc }),
            ]
          }));

          const apiResult2: ApiResult<InsertResultsWithData> = await appContext.api.saveJobDetail(JobNames.BTOrder, sqlInfos, {});
          setSavedEntity(cell.row.original.id.toString(), false);

          if (apiResult1.result.sharedUrl)
            window.open(`https://platform.tive.com/shared/shipment/${apiResult1.result.sharedUrl}`);
          else
            await showGlobalOkDialog(<p>No sipment found.</p>);
        }
      }
      else {
        if (cell.row.original.sharedURL && cell.row.original.sharedURL.length === 32)
          window.open(`https://platform.tive.com/shared/shipment/${cell.row.original.sharedURL}`);
        else
          await showGlobalOkDialog(<p>No sipment found.</p>);
        return;
      }
    }
  }

  if((cell.row.original.trType === 'M' || cell.row.original.trType === 'C')){
    switch (trStatus) {
      case 'Q':
        displayText = 'Start to Request';
        displayDateTime = trDate;
        tooltip = `${displayText} ${formatDateTime(displayDateTime)}`;
        imgSrc = OrchidTracking_Y;
        id='tmsYellowIcon';
        break;
      case 'failed':
        displayText = 'Invalid or Error';
        displayDateTime = trDate;
        tooltip = `${(l as any).trStatusDesc as string} ${formatDateTime(displayDateTime)}`;
        imgSrc = OrchidTracking_R;
        id='tmsRedIcon';
        break;
      case 'tracking_stopped':
        displayText = lastEvent;
        displayDateTime = lastEventDate;
        tooltip = `${displayText} ${formatDateTime(displayDateTime)}`;
        imgSrc = OrchidTracking_B;
        id='tmsBlueIcon';
        break;
      case 'pending':
        displayText = 'Pending';
        displayDateTime = lastEventDate;
        tooltip = '';
        imgSrc = OrchidTracking_G;
        id='tmsGreenIcon';
        break;
      case 'awaiting_manifest':
        displayText = 'Awaiting Manifest';
        displayDateTime = lastEventDate;
        tooltip = '';
        imgSrc = OrchidTracking_G;
        id='tmsGreenIcon';
        break;
      default:
        displayText = lastEvent;

        if(displayText != null && displayText.includes('eta')) displayText = displayText.replaceAll('eta', 'ETA');

        displayDateTime = lastEventDate;
        tooltip = `${displayText} ${formatDateTime(displayDateTime)}`;
        imgSrc = OrchidTracking_G;
        id='tmsGreenIcon';
        break;
    }

    return <div id={`${cell.column.id}-${row.index}`} className="ifms-table-align-left capitalize"
              style={{cursor: 'pointer',paddingLeft:'1px'}}
              data-tooltip={tooltip} >
                  <img style={{float:'left'}} height="16px" id={id} src={imgSrc} alt='' onClick={() => {jobListContext.setRowExtrasId(cell.row.original.id);
                    window.open(link);}} />
                  {cell.row.original.trackingNo ? <img style={{float:'left'}} height="16px" src={trakcingImgSrc} alt='' onClick={async() => { await goToTive(cell.row.original.trackingNo); }} />:<></>}
                  <div style={{marginLeft:'20px'}}>
                    {displayText} {formatDateTime(displayDateTime)}
                  </div>
            </div>
  } else{
    if(cell.row.original.trackingNo){
      id='ManifestTrackingIcon';
    }
    return <div id={`${cell.column.id}-${row.index}`} className="ifms-table-align-left capitalize" style={{cursor: 'pointer',paddingLeft:'1px'}}>
                {cell.row.original.trackingNo ? <img style={{float:'left'}} height="16px" id={id} src={trakcingImgSrc} alt='' onClick={async() => { await goToTive(cell.row.original.trackingNo); }} />
                : <></>}
   </div>
  }

}



function IsfRenderer({ cell, row, data }: any) {
  const l = data[row.index];
  const useIsf = (l as any).useIsf as boolean;

  if (useIsf) {
    const content = <img height="13px" src={UseAMSISfIcon} alt="" />;

    if (cell && cell.value) {
      return (
        <div className="ifms-table-default" id={`ifms-table-default-${row.index}`} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', minHeight: '22px' }}>{content}</div>
      );
    }
  } else {
    if (cell && cell.value) {
      return <div id={`${cell.column.id}-${row.index}`} className="ifms-table-default">
        <CheckBoxIcon value={true} />
      </div>;  
    }
  }

  return <div className="ifms-table-default ifms-check-box-icon-false"></div>;
}


function ChbRenderer({ cell, row, data }:any) {
  const l = data[row.index];
  const tooltip = l.chbRspCode === 'x' ? undefined : `${l.chbRspCode} - ${l.chbRspMsg}`;
  return <div id={`${cell.column.id}-${row.index}`} className="ifms-table-default" data-tooltip={tooltip}>{cell.value}</div>;
}

function LoadNoRenderer({cell, row, data}: any){
  const {switchToLoad} = useOrderOperations();

  if(!cell.value){
    return <div className="ifms-table-default">{cell.value}</div>;
  }
  return <PrimaryInverseButton onClick={() => switchToLoad(data[row.index])} style={{width: '100%', lineHeight:'1em'}}>{cell.value}</PrimaryInverseButton>

}
//
function DoNoRenderer({cell, row, data}: any){
  const {switchToLocalDo} = useOrderOperations();

  if(!cell.value){
    return <div className="ifms-table-default">{cell.value}</div>;
  }

  return <PrimaryInverseButton onClick={() => switchToLocalDo(data[row.index])} style={{width: '100%', lineHeight:'1em'}}>{cell.value}</PrimaryInverseButton>

}

function useOrderOperations(){
  const history = useHistory();

  function switchToLoad(order: BTOrderListItem|null){
    if(!order){
      return;
    }
    openNewPage(history, `/brokerageTrucking/loadPlan/view/${order.loadId}`, NavigationType.newPage );
  }

  function switchToLocalDo(order: BTOrderListItem|null){
    if(!order){
      return;
    }
    openNewPage(history, `/brokerageTrucking/localDO/view/${order.doId}`, NavigationType.newPage );
  }

  return {switchToLoad, switchToLocalDo};
}

function useListOperations (){
  const history = useHistory();
  const jobListContext = useContext(JobListViewContext);

  function switchToLoadFor(order: BTOrderListItem| null){
    if(!order){
      return;
    }
    const url = `/common/joblistview/btLoadPlan/load`;
    jobListContext.setFilterForScreenExternally(url,'id', 'Load #', order.loadId, 'u2Date', false, true, null, 'loadNo', order.loadNo??'', false, true);
    openNewPage(history, url, NavigationType.newPage);
  }

  function switchToLocalDoFor(order: BTOrderListItem | null){
    if(!order){
      return;
    }
    const url = `/common/joblistview/btLocalDO/localDO`;
    jobListContext.setFilterForScreenExternally(url, 'id', 'D/O #', order.doId, 'u2Date', false, true, null, 'doNo', order.doNo??'', false, true);
    openNewPage(history, url, NavigationType.newPage);
  }

  return {switchToLoadFor, switchToLocalDoFor};
}

function useSelectedOperations() {
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);
  const history = useHistory();
  const {switchToLoadFor, switchToLocalDoFor} = useListOperations();

  const selectedElement = jobListContext.selectedElement as BTOrderListItem;

  const [showGlobalOkDialog] = useGlobalOkDialog();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
  const channel = postal.channel('ajax');

  const setSavedEntityLoad = useSetEditedId([JobNames.BTLoadPlan]);

  async function create() {
    if (jobListContext.hasOpenedScreenStartingWithUrl('/brokerageTrucking/order/add')) {
      await showGlobalOkDialog(<p>New operation is already in progress.</p>);
      return;
    }

    openNewPage(history, '/brokerageTrucking/order/add', NavigationType.newPage);
  }

  async function deleteItem() {
    if (!selectedElement) {
      return;
    }

    if(!isNullOrEmpty(selectedElement.doNo)){
      await showGlobalOkDialog('Need to delete Local D/O first', false, null, "warning");
      return;
    }

    if(!isNullOrEmpty(selectedElement.loadNo)){
      await showGlobalOkDialog('Need to delete Load first', false, null, "warning");
      return;
    }


    if(
      jobListContext.hasOpenedScreenStartingWithUrl(`/brokerageTrucking/order/edit/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenStartingWithUrl(`/brokerageTrucking/order/view/${selectedElement.id}`) 
    ){
      await showGlobalOkDialog('Need to close Order first', false, null, "warning");
      return;
    }

    if (
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/bill/view/BTODR/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/bill/edit/BTODR/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/invoice/view/BTODR/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/invoice/edit/BTODR/${selectedElement.id}`) 
    ) {
      await showGlobalOkDialog('Need to close Bill/Invoice first.', false, null, "warning");
      return;
    }

    const doDelete = await showGlobalYesNoDialog(
      <div>
        <h3>Confirm to Delete?</h3>
      </div>
    ,false,1,true,'warning');

    if (doDelete) {
      const apiResult = await appContext.api.deleteJobDetail(JobNames.BTOrder, { id:selectedElement.id});
      if (apiResult && apiResult.success) {
        jobListContext.reloadData();
      } else {
        const message = apiResult?.message ?? 'Cannot delete!';
        await showGlobalOkDialog(message,false,null,'warning');
      }
    }
  }

  async function viewBillings() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;

    const viewUrl = `/brokerageTrucking/viewBillings/order/${id}`;

    if (jobListContext.hasOpenedScreenStartingWithUrl(viewUrl)) {
      await showGlobalOkDialog(<p>View operation is already in progress.</p>);
      return;
    }

    openNewPage(history, viewUrl, NavigationType.newPage);
  }

  async function viewProfit(viewEdit:boolean) {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;

    const editUrl  = `/brokerageTrucking/order/edit/${id}`;
    const viewUrl = `/brokerageTrucking/order/view/${id}`;
    
    //let url = `/brokerageTrucking/order/${viewEdit ? 'edit' : 'view'}/${id}`;
    let editUrlProfitTab = `${editUrl}/2`;
    let viewUrlProfitTab = `${viewUrl}/2`;

  if (viewEdit && jobListContext.hasOpenedScreenStartingWithUrlWithoutMe(`/brokerageTrucking/order/edit`, editUrl)) {
      await showGlobalOkDialog(<p>Edit operation is already in progress</p>);
      return;
    }
    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(viewEdit ? editUrlProfitTab : viewUrlProfitTab, [viewUrl, editUrl]);
  }

  async function edit() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const editUrl = `/brokerageTrucking/order/edit/${id}`;
    const viewUrl = `/brokerageTrucking/order/view/${id}`;

    // if (jobListContext.hasOpenedScreenStartingWithUrlWithoutMe('/brokerageTrucking/order/edit', editUrl)) {
    //   await showGlobalOkDialog(<p>Edit operation is already in progress.</p>);
    //   return;
    // }

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(editUrl, [editUrl, viewUrl]);
  }

  async function view() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const editUrl = `/brokerageTrucking/order/edit/${id}`;
    const viewUrl = `/brokerageTrucking/order/view/${id}`;
    
    const listSec = findSecurityTask(appContext, FmsSecTask.BTOrder);
    const urls = [viewUrl];
    if(listSec?.grantEdit) urls.push(editUrl);
    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(viewUrl, urls);
  }

  async function copy() {
    if (!selectedElement) {
      return;
    }

    if (jobListContext.hasOpenedScreenStartingWithUrl('/brokerageTrucking/order/add')) {
      await showGlobalOkDialog(<p>New operation is already in progress.</p>);
      return;
    }

    const id = selectedElement.id;
    openNewPage(history, `/brokerageTrucking/order/add?copyId=${id}`, NavigationType.newPage);
  }

  async function switchToAcctInfo(ot:BTOrderListItem|null) {
    if (!ot) {
      return;
    }

    if (jobListContext.hasOpenedScreenStartingWithUrl(`/accounting/Acct/${JobNames.BTOrder}/${ot.id}`)) {
      await showGlobalOkDialog(<p>View operation is already in progress.</p>);
      return;
    }
    
    openNewPage(history, `/accounting/Acct/${JobNames.BTOrder}/${ot.id}`, NavigationType.newPage);
  }

  function switchToLoad() {
    const selectedElement = jobListContext.selectedElement as BTOrderListItem;
    switchToLoadFor(selectedElement);
  }

  function switchToLocalDo() {

    const selectedElement = jobListContext.selectedElement as BTOrderListItem;
    switchToLocalDoFor(selectedElement);

  }

  async function recognize(isSet: boolean) {
    // if (selectedElement?.recognized !== 'R' && !selectedElement?.completed) {
    //   await showGlobalOkDialog(<p>Cannot recog because Load is not Completed.</p>);
    //   return;
    // }

    jobListContext.setRecogModalData({ isOpen: true, isSet: isSet });
  }

  return {create, deleteItem, edit, view, copy, recognize, viewBillings, switchToAcctInfo, viewProfit, switchToLoad, switchToLocalDo, setSavedEntityLoad};
}

function RightClickMenu({dismiss}:{dismiss: VoidFunction}) {
  const { create, deleteItem, edit, view, copy, recognize, viewBillings, viewProfit, switchToLoad, switchToLocalDo } = useSelectedOperations();
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as BTOrderListItem;
  const appContext = useContext(ApplicationContext);
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
  const listSec = findSecurityTask(appContext, FmsSecTask.BTOrder);
  const fmsGlobal = getFmsGlobal();

  async function processFileLock() {

    const fileLockResult = await appContext.api.opClose(JobNames.BTOrder, selectedElement.id, !selectedElement.isClosed);
    if (!!fileLockResult) {
      await showGlobalOkDialog(fileLockResult, false, null, 'warning');
      return;
    }

    if (selectedElement.isClosed && jobListContext.hasOpenedScreenStartingWithUrl(`/brokerageTrucking/order/edit/${selectedElement.id}`)) {
      const editModelKey = `editBTOrder${selectedElement.id}-/brokerageTrucking/order/edit`;
      const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
      if (keyMatch) {
        fastStorage[keyMatch].fileClosed = 0;
        fastStorage[keyMatch].isClosed = false;
        fastStorage[keyMatch].closedBy = '';
        fastStorage[keyMatch].closeDate = null;
      }
    }

    jobListContext.reloadData();
  }

  async function TrackRequestFunc() {
    if (!selectedElement) {
      return;
    }

    if (_.isEmpty(selectedElement.containerNo)) {
      await showGlobalOkDialog(<p>Empty container number.</p>);
      return;
    }

    await CheckAndDoTrackRequest(selectedElement.id, selectedElement.trType, selectedElement.trStatus, selectedElement.mblNo)
  }

  async function CheckAndDoTrackRequest(jobId: number, trType: string, trStatus: string, mblNo: string, cntrCount: number = 1) {
    let result: string = '';
    if (!await CheckTrStatus(jobId, trType, trStatus, cntrCount)) return result;
    
    const apiResult = await IsShippingLineSupported(mblNo?.substring(0, 4), RequestType.bl)
    if (!apiResult.success)
      return result;

    vcResult = apiResult.result;

    const errMsg = await CheckTrackRequestAllowed(cntrCount)
    if(!_.isEmpty(errMsg)){
      if (!errMsg.endsWith('?')){
        await showGlobalOkDialog(<p>{errMsg}</p>);
        return result;
      }
      else{
        const doClose = await showGlobalYesNoDialog(
          <div>
            <h3>{errMsg}</h3>
          </div>
        );
  
        if (!doClose) {
          return result;
        }
      }
    }

    jobListContext.setRowExtrasId(jobId);
    jobListContext.setTrackingRequestEmailList('OpenEmailOptionPopup');
  }

  async function CheckTrackRequestAllowed(countToSend: number) {
    let result = '';

    const perMonth = appContext.suntekSettings?.company?.containersPerMonth ?? 0;
    if (perMonth > 0) {
      const apiResult = await appContext.api.checkThisMonthRequests();
      if (perMonth - apiResult < countToSend) {
        result = `Credit for containers per month is limited.
This request will cause additional fee.
Do you want to request this tracking?`;
      }
    }
    return result;
  }

  async function IsShippingLineSupported(vcScac: string, reqType: string) {
    let apiResult: ApiResult<string> = { success: false, result: '', message: '' };

    if (_.isEmpty(vcScac)) {
      await showGlobalOkDialog(<p>Vessel carrier was not given. Please retry with valid Master B/L number.</p>);
      return apiResult;
    }

    apiResult = await appContext.api.trackingCheckShippingLine(vcScac);

    if(!apiResult || !apiResult.success){
      await showGlobalOkDialog(<p>{apiResult?.message ?? constants.LOAD_ERROR_MESSAGE}</p>);
      return apiResult;
    }
    else {
      switch (apiResult.result) {
        case 'X':
          await showGlobalOkDialog(<p>Tracking Service does not support Vessel carrier {`[${vcScac}]`}.</p>);
          apiResult.success = false;
          break;
        case RequestType.bl:
          if (reqType !== RequestType.bl) {
            await showGlobalOkDialog(<p>Vessel carrier {`[${vcScac}] support only Master B/L tracking.`}
Please retry from Master B/L list.</p>);
            apiResult.success = false;
          }
          break;
      }
    }
    return apiResult;
  }

  async function CheckTrStatus(jobId: number, trType: string, trStatus: string, cntrCount: number = 1) {
    if (!_.isEmpty(trType)) {
      if (trType === 'C') {
        // const apiResult = await appContext.api.getTrackRequestedContainerCountPerMbl(jobId);
        // if (apiResult >= cntrCount) {
        //   await showGlobalOkDialog(<p>All containers are already requested at {'['}Container List{']'}.</p>);
        //   return false;
        // }
        // else {
        //   await showGlobalOkDialog(<p>Part of containers are requested at [Container List].
        //     You can request tracking service for the remaining containers
        //   </p>);
        // }
      }
      // else if (trType === 'M' && !(trStatus === "failed" || trStatus === "C")) {
      //   await showGlobalOkDialog(<p>Tracking service was already requested at [Master B/L List].</p>);
      //   return false;
      // }
      else {
        jobListContext.setRowExtrasId(jobId);
        jobListContext.setTrackingRequestEmailList('OpenTrackRequestViewMode');
        return false;
      }
    }
    return true;
  }

  let showFileLock = (!selectedElement?.isClosed ? getFmsGlobal().CanFileLock : getFmsGlobal().CanFileUnlock);
  const lockCancelRecog = selectedElement?.recognized === 'R' && (selectedElement?.status === 'PC' || selectedElement?.status === 'OC');

  const items = [
    { label: 'New', shortcut: 'F2', separator: false, hidden: !listSec?.grantAdd },
    { label: 'View', shortcut: 'F9', separator: !listSec?.grantEdit && !listSec?.grantDel },
    { label: 'Edit', shortcut: 'F3', separator: !listSec?.grantDel, hidden: !listSec?.grantEdit },
    { label: 'Delete', shortcut: '', separator: true, hidden:!listSec?.grantDel, },
    { label: 'Go to Load List', shortcut: 'F4', separator: false},
    { label: 'Search', shortcut: 'F5', separator: false },
    { label: 'Go to Local D/O List', shortcut: 'F6', separator: false},
    { label: 'Memo', shortcut: 'F8', separator: true, newCol: true },
    { label: 'Copy', shortcut: 'Ctrl+F2', separator: false, hidden: !listSec?.grantAdd },
    { label: 'Bilings', shortcut: 'F7', separator: !listSec?.grantEdit },
    { label: 'Profit', shortcut: 'Ctrl+F7', separator: true, hidden: !listSec?.grantEdit },
    //{ label: 'Container Tracking', shortcut: '', separator: false },
    { label: 'Request Tracking Service', shortcut: '', separator: false, hidden: !appContext.suntekSettings?.company?.trackingService },
    { label: !selectedElement?.isClosed ? 'OP Close' : 'OP Open', shortcut: '', separator: false, hidden: !showFileLock || selectedElement?.draft },
    { label: selectedElement?.recognized !== 'R' ? 'Recog' : 'Undo Recog', shortcut: '', separator: false, disabled : lockCancelRecog, hidden: !getFmsGlobal().CanFinalize },
  ];

  const menuItems: ActionButtonItem[] = items.map((i, index) =>({
    label: <ToolboxMenuItem  name="os-list-sub-menu" width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    newCol: i.newCol,
    index,
    disabled: i?.disabled ?? false,
    hidden: i?.hidden ?? false,
  }));

  function onMenuItemSelected(item:IfmsMenuItem) {
    switch (item.index) {
      case 0:
        create();
        break;
      case 1:
        view();
        break;
      case 2:
        edit();
        break;
      case 3:
        deleteItem();
        break;
      case 4:
        switchToLoad();
        break;
      case 5:
        jobListContext.triggerTableSearch('F5');
        break;
      case 6:
        switchToLocalDo();
        break;
      case 7:
        jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
        break;
      case 8:
        copy();
        break;
      case 9:
        viewBillings();
        break;
      case 10:
        viewProfit(listSec?.grantEdit ? true : false);
        break;
      //case 9:
      //  openContainerTracking();
      //  break;
      case 11:
        TrackRequestFunc();
        break;
      case 12:
        processFileLock();
        break;
      case 13:
        recognize(selectedElement?.recognized !== 'R');
        break;
      default:
        break;
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      items={splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
      borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
    />
  );
}

function AfterMemoLogButtonCommands() {
  const jobListContext = useContext(JobListViewContext);
  const storage = useAppSelector(x => x.storage);
  const [listFilter, setListFilter, ] = useTypedFastStorage<number>('BTOrder-ListFilter', 0);
  useEffect(() => {
    changeBTOrderListData(listFilter || 0);
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [listFilter]);

  function changeBTOrderListData(listFilter: number){
    let listFilterType = ListFilterType.All;

    switch(listFilter) {
      case 0: 
        listFilterType = ListFilterType.All;
        break;
      case 1: 
        listFilterType = ListFilterType.NotClosed;
        break;
      case 2: 
        listFilterType = ListFilterType.NotDeparted;
        break;
      case 3: 
        listFilterType = ListFilterType.NotPlanned;
        break;
      case 4: 
        listFilterType = ListFilterType.Closed;
        break;
      case 5: 
        listFilterType = ListFilterType.Completed;
        break;
      case 6: 
        listFilterType = ListFilterType.NotCompleted;
        break;
      case 7: 
        listFilterType = ListFilterType.Arrived;
        break;
      case 8: 
        listFilterType = ListFilterType.NotInvoiced;
        break;
      case 9: 
        listFilterType = ListFilterType.NotInvoicedwLoadNo;
        break;
      case 10: 
        listFilterType = ListFilterType.NotPaidYet;
        break;
      case 11: 
        listFilterType = ListFilterType.ITNotValid;
        break;
      case 12: 
        listFilterType = ListFilterType.Departed;
        break;
    }
    if(listFilterType === ListFilterType.NotPlanned){
      jobListContext.setListOrderBy({
        orderBy: 'eta',
        orderByAscending: true,
      })
      jobListContext.setListFilterOrder(true);
    } else{
      jobListContext.setListFilterOrder(false);
    }
    jobListContext.setListFilterType(listFilterType);

  }
  
  
  const filterType =[
    {label: 'All', value: 0},
    {label: 'IT Not Validated', value:11},
    {label: 'Departed', value: 12},
    {label: 'Arrived', value: 7},
    {label: 'Closed', value: 4},
    {label: 'Completed', value: 5},
    {label: 'Not Completed', value: 6},
    {label: 'Not Planned (by Vessel ETA)', value:3},
    {label: 'Not Departed', value: 2},
    {label: 'Not Closed', value: 1},
    {label: 'Not Invoiced', value:8},
    {label: 'Not Invoiced w/Load #', value: 9},
    {label: 'Not Paid Yet', value: 10},

  ]

  return (
      <div style={{marginLeft:'10px', width:'180px', lineHeight:'14px', maxHeight:'300px'}}>
        <Select
          name="ifms-order-list-filter"
          placeholder="Filter"
          value={listFilter || 0}
          onChange={e => {setListFilter(Number(e.target.value))}}
          items={filterType}
          maxHeight='306px'
        />
      </div>
 
  )
}


function TrancationImpactButtonCommands() {
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as BTOrderListItem;
  const {switchJournal} = useJournal();
  const suntekSettings = useSuntekSettings();
  
  // if (!suntekSettings.accounting?.allowTransactionImpact) {
  //   return null;
  // }

  return (
    <PrimaryButton
      size="regular"
      onClick={()=> switchJournal(JobNames.BTOrder, selectedElement.id)}>
      Journal
    </PrimaryButton>
  );
}

function ListCommands() {
  const jobListContext = useContext(JobListViewContext);
  const [selectedPopupMenuItem, setSelectedPopupMenuItem] = useState<ActionButtonItem|null>(null);
  
  const selectedElement = jobListContext.selectedElement as BTOrderListItem;

  const {deleteItem, edit, view, copy, viewBillings, setSavedEntityLoad} = useSelectedOperations();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const appContext = useContext(ApplicationContext);
  const { viewReport } = useReportViewer();
  const setSavedEntityAfterRecog = useSetEditedId([JobNames.BTOrder, JobNames.SlipJournal]);

  function hasOpenedViewOrEditFor(id: number) {
    return jobListContext.hasOpenedScreenStartingWithUrl(`/brokerageTrucking/order/edit/${id}`) || jobListContext.hasOpenedScreenStartingWithUrl(`/brokerageTrucking/order/view/${id}`);
  }

  function doAfterRecog(){
    jobListContext.reloadData();
    setSavedEntityLoad(selectedElement.loadId?.toString(), false);
    setSavedEntityAfterRecog('0', false, false, true);
  }

  const onRecogModalClose = () => {
    jobListContext.setRecogModalData({ isOpen: false, isSet: false });
  }

  function hasOpenedNew() {
    return jobListContext.hasOpenedScreenStartingWithUrl(`/brokerageTrucking/order/add`);
  }

  const onPopupClose = () => {
    setSelectedPopupMenuItem(null);
  }

  async function onSubMenuClick(fmsSubMenu: FmsSubMenu) {
    setSelectedPopupMenuItem(null);

    if (!selectedElement) {
      return;
    }
    
    const args = await getSelectedSubMenuArgs(fmsSubMenu, JobNames.BTOrder, selectedElement, appContext, showGlobalYesNoDialog, showGlobalOkDialog);
    if(args){
      viewReport(args, "", true);
    }
  }

  async function customerBalance() {
    if (selectedElement.billToId <= 0) {
      await showGlobalOkDialog(<p>You didn't enter Customer.</p>,false,null,'warning');
      return;
    }
    setSelectedPopupMenuItem({
      label: 'Balance',
      popupWidth: 780,
      popupComponent:
        <CustomerBalanceDetails
          jobId={selectedElement.id}
          jobName={JobNames.Invoice}
          onPopupClose={onPopupClose}
          //toDate={invoice.postDate || ''}
          toDate={nowDate()}
          comId={selectedElement.billToId}
          comType={'C'}
          branch={''}
          subCode={''}
          customerName={selectedElement.billTo}
        />
    });
  }


  const listSec = findSecurityTask(appContext, FmsSecTask.BTOrder);

  const hasSelectedRow = !!selectedElement;
  const canBeDeleted = hasSelectedRow && listSec?.grantDel;
  const canBeCopied = hasSelectedRow && !hasOpenedNew() && listSec?.grantAdd;
  const canBeAdd = !hasOpenedNew() && listSec?.grantAdd;
  const canBeEdit = hasSelectedRow && listSec?.grantEdit;

  return (
    <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}>
      <div className="ifms-common-no-vertical-separator">
        <UniqueLinkButton name='btOrder-list-add-button' display="primary" size="regular" link="/brokerageTrucking/order/add" disabled={!canBeAdd}
                          label="New"/>&nbsp;
        <PrimaryButton name='btOrder-list-view-button' size="regular" disabled={!hasSelectedRow} onClick={view}>View</PrimaryButton>&nbsp;
        <PrimaryButton name='btOrder-list-edit-button' size="regular" disabled={!canBeEdit} onClick={edit}>Edit</PrimaryButton>&nbsp;
        <PrimaryButton name='btOrder-list-delete-button' size="regular" disabled={!canBeDeleted} onClick={deleteItem}>Delete</PrimaryButton>&nbsp;
        <PrimaryButton name='btOrder-list-copy-button' size="regular" disabled={!canBeCopied} onClick={copy}>Copy</PrimaryButton>
      </div>
      <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}>
        <PrimaryButton size="regular" onClick={viewBillings}>Billings</PrimaryButton>&nbsp;
        {appContext.user?.isSuntekAdmin && <PrimaryButton size="regular" onClick={() => setSelectedPopupMenuItem({label: 'Delete History (Manifest)', popupWidth: 1120, popupComponent: <DeleteHistory jobName={JobNames.BTOrder} /> })}>Delete History</PrimaryButton>}&nbsp;
        <PrimaryButton
          name='invoice-list-balance-button' 
          size="regular"
          disabled={!hasSelectedRow}
          onClick={customerBalance}>
          Balance
        </PrimaryButton>
      </div>

      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.popupComponent ? (
        <IfmsModal isBlueHeader cancelOnEsc onCancel={onPopupClose} draggable isOpen={!!selectedPopupMenuItem} title={selectedPopupMenuItem?.popupLabel || selectedPopupMenuItem?.label} width={`${selectedPopupMenuItem?.popupWidth || 760}px`}>
          {cloneElement(selectedPopupMenuItem.popupComponent!, {onPopupClose})}
        </IfmsModal>
      ) : null}
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.subMenu ? onSubMenuClick(selectedPopupMenuItem.subMenu) : null}
      {jobListContext.recogModalData?.isOpen ? (
        <RecogModal reloadData={doAfterRecog} onCancel={onRecogModalClose} mTbId={selectedElement.loadId} mTbName={"T_BTLOAD"} isSet={jobListContext.recogModalData?.isSet} ></RecogModal>
      ) : null}
    </div>
  );
}

function ListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function ListViewExtras({
  hideLogHistory
}: any,
) {
  useFunctionKeys({onFunction: onFunctionKey});

  const appContext = useContext(ApplicationContext);
  const jobListContext = useContext(JobListViewContext);
  const history = useHistory();
  const listSec = findSecurityTask(appContext, FmsSecTask.BTOrder);

  const {copy, create, edit, view, viewBillings, viewProfit, switchToLoad, switchToLocalDo } = useSelectedOperations();

  const [unprocessedFkey, setUnprocessedFkey] = useState<string | null>(null);

  useEffect(() => {
      if (!unprocessedFkey) {
        return;
      }

      doProcessFkey();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === 'F6') {
      switchToLocalDo();
    } else if (unprocessedFkey === "F2") {
      if(listSec?.grantAdd)
        create();
    } else if (unprocessedFkey === "CTRL+F2") {
      if(listSec?.grantAdd)
        copy();
    } else if (unprocessedFkey === "F3") {
      if(listSec?.grantEdit)
        edit();
    } else if (unprocessedFkey === "F4") {
      switchToLoad();
    } else if (unprocessedFkey === "F9") {
      view();
    } else if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    } else if (unprocessedFkey === "F8") {
      jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');
    } else if (unprocessedFkey === "F7") {
      viewBillings();
    }else if (unprocessedFkey === "CTRL+F7") {
      viewProfit(listSec?.grantEdit ? true : false);
    }

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey: string) {
    if (['F6', 'F2', 'CTRL+F2', 'F3', 'F9', 'F11', 'F8', 'F7', 'CTRL+F7', 'F4'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  
  const infoHeadline = `PRO #: ${(jobListContext.selectedElement as BTOrderListItem|null)?.orderNo ?? ''}`;

  return (
    <InfoAreaDrawer
      showContent={jobListContext.infoAreaContent}
      jobName={JobNames.BTOrder}
      jobId={(jobListContext.selectedElement as BTOrderListItem | null)?.id ?? 0}
      customTabs={[
        {
          headline: 'Billings Info',
          contentLoader: loadInfoAreaInvoiceBillCrDb,
          params: { appContext, jobListContext, history, infoHeadline }
        },
      ]}
      onClose={() => jobListContext.setInfoAreaContent('none')}
      hideLogHistory={hideLogHistory}
    />
  );
}

function formatData(data:Array<BTOrderListItem>) {
  return data.map(d => ({
    ...d,
  }));
}

/**
 * Concrete implementation for BT Order List screen
 *
 * @class ListView
 * @extends {AbstractListView}
 */
class ListView extends AbstractListView {
  async fetchAndFormatData(api: any, search: Search): Promise<DataFetchResult> {
    const apiResult = await api.getListItems(
      JobNames.BTOrder,
      'BTOrderListItem',
      BTOrderListItem.calculateSearchParameters(search, BTOrderListItem.MapSearchFields, [ 'invStat', 'billStat']),
      1,
      search.pageSize);

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return {data: [], totalCount: 0};
    }

    return {data: formatData(apiResult.entities), totalCount: apiResult.totalCount};
  }

  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
      {
        accessor: 'invStat',
        renderer: BillInvoiceCrdbFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'billStat',
        renderer: BillInvoiceCrdbFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'recognized',
        renderer: RecognizedFilterRenderer,
        searchValueExtractor: (v:any|null|undefined) => v,
      },
      {
        accessor: 'mot',
        renderer: MOTFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
    ];
  }

  getInfoAreaEntityId() {
    return constants.infoAreaEntity.oceanImportMbl;
  }

  getRowRenderers(): ListRowRenderer[] {
    return BTOrderListItem.getExportCollection().map(x => {
      const colRenderer:ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      if(x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
      if(x.align === XCol.XAlignType.Right) colRenderer.Cell = TextAlignRightRenderer;
      if (x.dataIndex === "status") {
        colRenderer.Cell = IndicatorRenderer;
      }
      else if (x.dataIndex === "draft") {
        colRenderer.Cell = NullableCheckboxIconRenderer;
      }
      // else if(x.dataIndex === 'trStatus'){
      //   colRenderer.Cell = () => (<div/>);
      // }
      else if (x.dataIndex === 'trStatus'){
        const appContext = useContext(ApplicationContext);
        colRenderer.Cell = LastEventRenderer;
        colRenderer.Header =  () => <div><img style={{float:'left', marginRight:'5px'}} height="16px" src={appContext.useDarkMode? OrchidTracking_Wh: OrchidTracking_Bl} alt='' />Orchid Tracking</div>;
      } 
      else if (x.dataIndex === "useAmsBlNo") colRenderer.Cell = AmsRenderer;
      else if (x.dataIndex === 'useIsfNo') colRenderer.Cell = IsfRenderer;
      else if (x.dataIndex === 'chbRspCode') colRenderer.Cell = ChbRenderer;
      else if (x.dataIndex ===  'loadNo') colRenderer.Cell = LoadNoRenderer;
      else if (x.dataIndex === 'doNo') colRenderer.Cell = DoNoRenderer;
      else if (x.dataIndex === "recognized") colRenderer.Cell = RecognizedRenderer;
      else if(x.type === XCol.XCellType.Bool || x.type === XCol.XCellType.StrBool) colRenderer.Cell = NullableCheckboxIconRenderer;
      else if(x.type === XCol.XCellType.Date) colRenderer.Cell = DateRenderer;
      else if(x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      else if (x.type === XCol.XCellType.Double) {
        if (x.dataIndex === 'pkgs' || x.dataIndex === 'lbs')
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={0} />;
        else if (x.dataIndex === 'cbm') {
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={3} />;
        }
        else
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={2} />;
      }
      return colRenderer;
    });
  }

  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({ accessor: 'status', changedValue: (value: any) => { return value['status'] === 'PC' ? 'Period Close' : '' } });
    colRenderer.push({ accessor: 'draft', changedValue: (value: any) => { return nullableCheckBoxValue(value['draft']) } });
    colRenderer.push({ accessor: 'trStatus', changedValue: (value: any) => { return formatTrackingType(value['trStatus'], value['lastEvent']) } });
    colRenderer.push({ accessor: 'useAmsBlNo', changedValue: (value: any) => { return nullableCheckBoxValue(value['useAmsBlNo']) } });
    colRenderer.push({ accessor: 'useIsfNo', changedValue: (value: any) => { return nullableCheckBoxValue(value['useIsfNo']) } });
    colRenderer.push({ accessor: 'pkgs', changedValue: (value: any) => { return Decimalformat(value['pkgs'],0) } });
    colRenderer.push({ accessor: 'lbs', changedValue: (value: any) => { return Decimalformat(value['lbs'],0) } });
    colRenderer.push({ accessor: 'cbm', changedValue: (value: any) => { return Decimalformat(value['cbm'],3) } });
    return colRenderer;
  }

  renderRowExtras(rowId: number | null, context: IJobListViewContext, cell: any, appContext: any): React.ReactNode | null {
    if (!rowId) {
      return null;
    }

    function onCloseTracking49Popup() {
     const storageKey = `bt-trackrequest-${rowId}`;
     fastStorage[storageKey] = null;
     context.setRowExtrasId(null);
     context.setTrackingRequestEmailList(undefined);
     vcResult = '';
   }

   function onCloseEmailOptionPopup(emailList: string | undefined) {
     const storageKey = `emailoption-${rowId}`;
     fastStorage[storageKey] = null;
     if (_.isUndefined(emailList)){
       context.setRowExtrasId(null);
       context.setTrackingRequestEmailList(undefined);
     }
     else
       context.setTrackingRequestEmailList(emailList);
   }

    function getTrackRequestTitle(trStatus: string) {
      return 'Tracking Request' + (!_.isEmpty(trStatus) && trStatus !== 'Q' ? ` - ${trStatus.toUpperCase().replace('_', ' ')}` : '');
    }

    function getEmailOptionTitle() {
      return `[Container #${cell.row.original.containerNo}] Tracking Request: Choose email notice recipients`;
    }
    
    if (!_.isUndefined(context.trackingRequestEmailList)) {
      if (context.trackingRequestEmailList === 'OpenEmailOptionPopup')
        return (
          <IfmsModal isBlueHeader cancelOnEsc onCancel={() => onCloseEmailOptionPopup(undefined)} draggable isOpen title={getEmailOptionTitle()} width="790px">
            <EmailOptionPopup
              jobId={rowId}
              storageKey={`emailoption-${rowId}`}
              onClose={onCloseEmailOptionPopup}
              jobName={JobNames.BTOrder}
              isUsedTrackingRequest={true}
            />
          </IfmsModal>
        );
      else {
        return (
          <IfmsModal isBlueHeader cancelOnEsc onCancel={onCloseTracking49Popup} draggable isOpen title={getTrackRequestTitle(cell.row.original.trStatus)} width="500px">
            <TrackingRequest
              jobId={rowId}
              storageKey={`bt-trackrequest-${rowId}`}
              onClose={onCloseTracking49Popup}
              jobName={JobNames.BTOrder}
              trStatus={cell.row.original.trStatus}
              trType={!_.isUndefined(context.trackingRequestEmailList) && context.trackingRequestEmailList !== 'OpenTrackRequestViewMode' ? (vcResult === RequestType.bl ? 'M' : 'C') : cell.row.original.trType}
              mode={!_.isUndefined(context.trackingRequestEmailList) && context.trackingRequestEmailList !== 'OpenTrackRequestViewMode' ? 'new' : 'view'}
              vcResult={vcResult}
              containerNo={cell.row.original.containerNo}
            />
          </IfmsModal>
        );
      }
    }
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'u2Date',
      orderByAscending: false,
    };
  }

  getTableSettings(): TableSettings {
    const tsettings =  brokerageTruckingOrderList;
    const cols = BTOrderListItem.getExportCollection();
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type};
    });
    return tsettings;
  }

  renderCommands() {
    return (
      <ListCommands/>
    );
  }

  renderBeforeConfigureButton() {
    return (
      <ListToolbar/>
    );
  }

  renderExtras(hideLogHistory: boolean) {
    return <ListViewExtras hideLogHistory={hideLogHistory} />
  }

  getViewUrlFor(row: BTOrderListItem) {
    return row && row.id ? `/brokerageTrucking/order/view/${row.id}` : '';
  }

  getListViewTitle() {
    return 'Manifest List';
  };

  renderAdditionalCommands() {
    return <JobListSuntekCommand jobName={JobNames.BTOrder} keyProp='id' showAdjustBalance={false} />;
  }

  hasRightClickContext(): boolean {
    return true;
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} />;
  }

  commandsAfterMemoLogBtn():React.ReactNode{
    return <AfterMemoLogButtonCommands />
  }

  transactionImpactBtn(): React.ReactNode {
    return <TrancationImpactButtonCommands/>
  }
  
  useLogHistory(): boolean {
    return true;
  }
}

export default ListView;

